<app-mobile-frame>
  <!-- START: Gmail inbox top bar -->
  <div frameTop class="gm-inbox-topbar">
    <div class="gm-inbox-searchbar d-flex flex-row align-items-center justify-content-between">
      <i class="bi bi-list gm-inbox-icon"></i>
      <span class="gm-inbox-avatar placeholder"></span>
    </div>
  </div>
  <!-- END: Gmail inbox top bar -->

  <div class="gm-inbox">
    <div class="gm-inbox-tabs">
      <span class="gm-inbox-tab-bar placeholder"></span>
    </div>

    <!-- START: Real ad — EU collapsed row: headline only, links straight out -->
    <a
      [href]="data.url"
      target="_blank"
      rel="noopener noreferrer"
      class="gm-inbox-promo d-flex flex-row align-items-center"
    >
      <img
        *ngIf="creativeImage"
        class="gm-inbox-promo-thumb"
        [style.aspect-ratio]="thumbAspectRatio"
        [src]="creativeImage"
        alt=""
      />
      <div
        *ngIf="!creativeImage"
        class="gm-inbox-promo-thumb creative-missing"
        [style.aspect-ratio]="thumbAspectRatio"
        [title]="missingDimensionLabel"
      >
        {{ missingDimensionShortLabel }}
      </div>

      <div class="gm-inbox-promo-copy">
        <div class="gm-inbox-promo-meta">
          <span class="gm-inbox-promo-label">Ad</span>
          <span>&middot;</span>
          <span class="gm-inbox-promo-sender">Valamar</span>
          <i class="bi bi-box-arrow-up-right gm-inbox-promo-link-icon"></i>
        </div>
        <div class="gm-inbox-promo-headline">
          {{ data.headlines[0] || "Your headline appears here" }}
        </div>
      </div>

      <i class="bi bi-three-dots-vertical gm-inbox-promo-more"></i>
    </a>
    <!-- END: Real ad -->

    <!-- Rest of the inbox, skeleton filler -->
    <div class="gm-inbox-row d-flex flex-row" *ngFor="let row of inboxSkeletonRows">
      <span class="gm-inbox-row-avatar placeholder"></span>
      <div class="gm-inbox-row-lines d-flex flex-column">
        <span class="gm-inbox-row-bar placeholder"></span>
        <span class="gm-inbox-row-bar gm-inbox-row-bar-short placeholder"></span>
      </div>
    </div>
  </div>

  <!-- START: Gmail bottom nav -->
  <div
    frameBottom
    class="gm-inbox-bottomnav d-flex flex-row justify-content-around align-items-center"
  >
    <span class="gm-inbox-bottomnav-btn">
      <i class="bi bi-envelope-fill"></i>
    </span>
    <i class="bi bi-chat-dots gm-inbox-bottomnav-icon"></i>
    <i class="bi bi-camera-video gm-inbox-bottomnav-icon"></i>
  </div>
  <!-- END: Gmail bottom nav -->
</app-mobile-frame>
